export class CartAbandonmentHeartbeatAPIRequestCart {
    static of(props) {
        const data = [];
        for (const [, value] of Object.entries(props)) {
            value.map(prop => {
                data.push({
                    start: new Date(prop.startDate).toISOString(),
                    end: new Date(prop.endDate).toISOString(),
                    guestAges: prop.guestAges,
                    services: prop.selectedServices,
                    inventory: prop.inventory,
                    id: prop.id,
                    numberOfUnits: prop.numberOfUnits,
                    propertyTicker: prop.propertyTicker,
                });
            });
        }
        return data;
    }
}
